import * as React from 'react';

import FontAwesome from 'components/FontAwesome';
import bem from 'utils/bem';

const messageBlock = bem('selected-message');

export type SelectedMessageProps = {
  fileType: 'audio' | 'video';
  additionalMessage?: React.ReactNode;
  children?: React.ReactNode;
};

const SelectedMessage: React.FC<SelectedMessageProps> = ({
  fileType,
  additionalMessage,
  children,
}) => (
  <div className={messageBlock()}>
    <div className={messageBlock('title')}>{`${fileType} selected`}</div>
    <FontAwesome className={messageBlock('icon')} icon="check" />
    {additionalMessage && (
      <div className={messageBlock('additional-message')}>
        {additionalMessage}
      </div>
    )}
    {children}
  </div>
);

export default SelectedMessage;
